// Features/Line-Quantity/Events/Change-Start.ts
function dispatchChangeStart(target, detail) {
  const slug = `Line-Item-Quantity:Change:Start`;
  const event = new CustomEvent(slug, {
    bubbles: true,
    detail
  });
  target.dispatchEvent(event);
}
// Features/Line-Quantity/Events/Change-End.ts
function dispatchChangeEnd(target, detail) {
  const slug = `Line-Item-Quantity:Change:End`;
  const event = new CustomEvent(slug, {
    bubbles: true,
    detail
  });
  target.dispatchEvent(event);
}
// Features/Line-Quantity/Component.ts
import {
  dispatchCartRefresh,
  dispatchCartChange
} from "Misc";
class LineQuantity extends CustomHTMLElement {
  connectedCallback() {
    const { delegate } = this;
    delegate.on("change", "input", this.onInput.bind(this));
    delegate.on("click", "a", this.onLink.bind(this));
  }
  onLink(event, link) {
    event.preventDefault();
    this.updateFromLink(link.href);
  }
  onInput(_event, input) {
    const quantity = input.value;
    const line = input.getAttribute("data-line");
    const url = new URL(window.themeVariables.routes.cartChangeUrl, window.location.href);
    const params = url.searchParams;
    params.set("quantity", quantity);
    params.set("line", line);
    this.updateFromLink(url.href);
  }
  async updateFromLink(link) {
    const changeUrl = new URL(link, window.location.href);
    const search = changeUrl.searchParams, line = search.get("line"), id = search.get("id");
    const quantity = parseInt(search.get("quantity"));
    await this.updateTo({
      quantity,
      line,
      id
    });
  }
  async updateTo({ quantity, line, id }) {
    const delay = quantity === 0 ? 600 : 750;
    this.dataset.disabled = String(true);
    dispatchChangeStart(this, {
      newLineQuantity: quantity
    });
    const payload = {
      quantity,
      line,
      id
    };
    const body = JSON.stringify(payload);
    const url = window.themeVariables.routes.cartChangeUrl + ".js";
    await fetch(url, {
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body
    });
    const cart = await Cart.query();
    dispatchChangeEnd(this, {
      newLineQuantity: quantity,
      delay,
      cart
    });
    setTimeout(() => {
      this.dataset.disabled = String(false);
    }, delay);
    dispatchCartChange({ cart });
    dispatchCartRefresh({
      replacementDelay: delay,
      cart
    });
  }
}

// Features/Line-Quantity/mod.ts
window.customElements.define("line-item-quantity", LineQuantity);
export {
  dispatchChangeStart,
  dispatchChangeEnd
};
